<template>
  <div class="login-kind-choice">
    <p class="login-kind-choice__lead">같은 아이디가 여러 계정에 있습니다.</p>
    <p class="login-kind-choice__ask">어느 계정으로 들어가시겠습니까?</p>
    <div class="login-kind-choice__actions">
      <button
        v-if="kinds.includes('member')"
        type="button"
        class="login-kind-choice__btn login-kind-choice__btn--member"
        :disabled="busy"
        @click="emit('pick', 'member')"
      >
        일반회원
      </button>
      <button
        v-if="kinds.includes('seller')"
        type="button"
        class="login-kind-choice__btn login-kind-choice__btn--seller"
        :disabled="busy"
        @click="emit('pick', 'seller')"
      >
        판매업체
      </button>
      <button
        v-if="kinds.includes('admin')"
        type="button"
        class="login-kind-choice__btn login-kind-choice__btn--admin"
        :disabled="busy"
        @click="emit('pick', 'admin')"
      >
        관리자
      </button>
    </div>
    <button type="button" class="login-kind-choice__reset" :disabled="busy" @click="emit('reset')">
      다시 입력
    </button>
  </div>
</template>

<script setup lang="ts">
import type { PublicLoginKind } from '@/api/publicLogin'

withDefaults(
  defineProps<{
    kinds?: PublicLoginKind[]
    busy?: boolean
  }>(),
  {
    kinds: () => ['member', 'seller'],
  },
)

const emit = defineEmits<{
  pick: [kind: PublicLoginKind]
  reset: []
}>()
</script>

<style lang="scss" src="./PublicLoginKindChoice.scss"></style>
